// @mui material components

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

import { useQuery } from '@tanstack/react-query';

import { useNavigate, useParams } from 'react-router-dom';

import { Grid } from "@mui/material";
import moment from "moment";
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";

import crowdCountingAPI from "../../api/crowd_counting";
import groupAPI from "../../../../api/groups";
import userAPI from "../../../../api/user";

import { ArrowBack } from "@mui/icons-material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import HeatmapSettings from "modules/crowdcounting/components/Settings";
import MainView from "../../components/MainView";

import { twoDatesRelative } from "helper/formatting";
import { useAuth0 } from "@auth0/auth0-react";
import StationDashboardContainer from "modules/crowdcounting/components/LineCounter/layouts/dashboard/DashboardContainer";
import DashboardContainer from "modules/crowdcounting/components/LineCounter2/layouts/dashboard/index2";


// import ObjModel from "nextus/Models/ObjModel";


function CrowdCountingEventView({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {

    const params = useParams();
    const navigate = useNavigate();

    let group_ids = [];
    let device_uuids = [];
    let single_device = typeof params.uuid != 'undefined';

    //place holder data


    const goUpOneLevel = () => {
        let path = '..';
        console.log(navigate)
        navigate(path, { relative: "path" });
    }

    const navigateToDevice = (uuid) => {
        if (typeof params.uuid == 'undefined') {
            let path = './' + uuid;
            navigate(path, { relative: "path" });
        }
    }

    crowdCountingAPI.loadToken(useAuth0());
    groupAPI.loadToken(useAuth0());
    userAPI.loadToken(useAuth0());

    const selected_user = useQuery({
        queryKey: ['getUser'],
        queryFn: async () => {
            return await userAPI.getUser();
        }
    });

    const [settings, setSettings] = useState({
        "buses": false,
        "trams": false,
        "time_of_day": false
    })

    useEffect(() => {
        setSidebarState('hidden');

    }, [sidebarState]);

    const event = useQuery({
        queryKey: ['getCameraEvents', params.event_id],
        queryFn: async () => {
            return crowdCountingAPI.getCameraEvents(params.event_id)
        }
    });


    if (!single_device && event.data) {
        group_ids = event.data.event.group_ids;
    }
    else {
        device_uuids = [params.uuid];
    }

    const groups = useQuery({
        enabled: !single_device && !!event.data,
        queryKey: ['getGroupDeviceUUIDSWithIDs', ...group_ids],
        queryFn: async () => {
            return await groupAPI.getGroupDeviceUUIDSWithIDs(group_ids);
        }
    });

    if (groups.data) {
        device_uuids = groups.data;
    }

    let [startLimit, endLimit] = [0, 0]


    if (event.data && device_uuids.length) {
        startLimit = moment(event.data.event.start_time).unix()
        endLimit = moment(event.data.event.end_time).unix()

        let hasLive = endLimit > moment().unix()

        // let hasLive = true;
        if (hasLive) {
            endLimit = moment().unix()
        }

        // hasLive = true
        if (event.data?.event.type == "egress") {
            return (<DashboardContainer {...{ device_uuids, event: event.data.event }} />)
        }
        

// return "";
        return (
            <SoftBox p={3}
                sx={({ palette: { white }, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                    boxShadow: navbarBoxShadow,
                    backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                    // backgroundColor: rgba(white.main, 0.8),
                    borderRadius: borderRadius.xl,
                    height: 'calc(100% - 50px)',
                    width: 'calc(100% - 50px)',
                    overflowY: 'auto',
                    '::-webkit-scrollbar': {
                        backgroundColor: 'transparent',
                        width: '8px',
                    },
                    '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                        backgroundColor: 'transparent',
                    },
                    '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                        backgroundColor: '#babac0',
                        borderRadius: '6px',
                        border: `1px solid ${rgba(white.main, 0.8)}`,
                    },
                    '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                        display: 'none',
                    },
                })}
            >
                <SoftBox sx={{ height: '100px' }}>
                    <Grid container spacing={3} mb={2}>
                        <Grid item xs={12} md={2} sx={{ transition: 'all 0.7s ease-in-out' }}>
                            <SoftButton onClick={goUpOneLevel}>
                                <SoftTypography><ArrowBack /> {single_device ? "All Cameras" : "To Event List"}</SoftTypography>
                            </SoftButton>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ transition: 'all 0.7s ease-in-out' }} align='center'>
                            <SoftBox>
                                <SoftTypography variant="h2" sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '1', // Limit to 2 lines
                                    WebkitBoxOrient: 'vertical',
                                }}>{event.data.event.name} - {twoDatesRelative(event.data.event.start_time, event.data.event.end_time, Date.now())}</SoftTypography>
                            </SoftBox>
                        </Grid>
                        {/* <Grid item xs={2} sx={{ transition: 'all 0.7s ease-in-out' }} align='right'>
                        <HeatmapSettings {... { settings, setSettings }}></HeatmapSettings>
                    </Grid> */}
                    </Grid>
                </SoftBox>

                <SoftBox sx={{ height: "calc(100% - 50px)" }}>
                    {event.data?.event.type == "egress" &&
                        <DashboardContainer {...{ device_uuids, event: event.data.event }} />}
                    {event.data?.event.type != "egress" &&
                        <MainView {...{ device_uuids, event: event.data, startLimit, endLimit, settings, navigateToDevice, hasLive, selected_user }} />}
                </SoftBox >
            </SoftBox>
        )
    }
    else {
        return "";
    }
}



CrowdCountingEventView.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default CrowdCountingEventView;
